export default defineNuxtPlugin((nuxtApp) => {
    const logger = import.meta.client? nuxtApp.$log : nuxtApp.$logger;

    nuxtApp.hook('app:error', (err, context) => {
      logger.error(`Global error captured: ${err.toString()}, context: ${context}`);
    });

    nuxtApp.hook('app:created', (app) => {
      app.config.warnHandler = (msg, vm, trace) => {
        logger.warn(`Global warning handler warn found ${msg}`)
        // Optionally, send warnings to an external service
      };
    });

  });